import React from 'react'

import BrowserHeader from './headers/BrowserHeader'
import MobileAppHeader from './headers/MobileAppHeader'

const SwitchHeader = (props: any) => (props.$isMobileApp ? <MobileAppHeader {...props} /> : <BrowserHeader {...props} />)

export default SwitchHeader
